<template>
  <div>
    <div class="flex">
        <button class="btn btn-small col-6 mr2" @click="openCreatorProfileSelection();">{{$t('eingabe_export_pdf_complete_btn_text_1')}} {{$t('eingabe_export_pdf_complete_btn_text_2')}}</button><br/><br/>
        <button class="btn btn-small col-6 table" @click="doImageExportLink();" target="_blank">{{$t('eingabe_export_pdf_graphiconly_btn_text_1')}}<br>{{$t('eingabe_export_pdf_graphiconly_btn_text_2')}}</button><br/><br/>
    </div>
  </div>
</template>

<script>

import { EventBus } from "@/event-bus.js";
import axios from 'axios';
// import lightbox from './lightbox.vue'

export default {
  name: 'ExportBtns',
  data() {
    return {
      debug: false,
      
      appsettings_id: 0,
      projects_id: 0,

      // Login Daten
      userdata: {},
      session: {},
      loginStatus: false,
      chosen_creator_profile: {},
    }
  },
  props: {
    calcName: String,
    calcDescription: String,
    projectName: String,
    projectDescription: String,
    
  },
  components: {
    // 'lightbox': lightbox
  },
  created() {
    
    EventBus.$on('loginSuccessfulSubComponents', (payload) => {
      console.log('Results.vue recieved Event: "loginSuccessfulSubComponents"!');
      this.userdata = payload.userdata;
      this.session = payload.session;
      this.loginStatus = true;
    });

    EventBus.$on('do_pdf_export', () => {
      this.doPdfExportLink();
    });


    
    
    
    
  }, 
  methods: {
    

    log: function (obj) {
      if(this.debug) {
        this.log(obj)
      }
    },
    openCreatorProfileSelection(){
      EventBus.$emit('open_creatorProfileSelectionModal');
    },
    doPdfExportLink(payload) {

      let url =  process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/preparepdfexport/json';
      let data = {};
      let currentObj = this;

      data.calculationsid = this.$route.params.calculationid
      data.creator_profile_id = payload.id
      
      let merged = {...data, ...currentObj.session};
     
      axios.post(url, merged)
        .then(response => {
          if(response.data.success) {
            console.log('Ergebnis von Result: ')
            let result = window.open(response.data.link);
            console.log(result)
            if(result == null) {
              // MEldung ausgeben, das 
              alert('Bitte PopUp Blocker deaktivieren!')
            }
            // window.open(response.data.link);
          } else {
            alert('Leider trat ein unerwarteter Fehler bei der Erstellung der PDF-Datei auf!')
          }
        }).catch(function () {
          currentObj.log('catch Function of AJAX-Called... error()');
          
        });
    },
    doPdfExportLink_2() {

      let url =  process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/preparepdfexport2/json';
      let data = {};
      let currentObj = this;

      data.calculationsid = this.$route.params.calculationid
      
      let merged = {...data, ...currentObj.session};
     
      axios.post(url, merged)
        .then(response => {
          if(response.data.success) {
            window.open(response.data.link);
          } else {
            alert('Leider trat ein unerwarteter Fehler bei der Erstellung der PDF-Datei auf!')
          }
        }).catch(function () {
          currentObj.log('catch Function of AJAX-Called... error()');
          
        });
    },
    doImageExportLink() {

      let url =  process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/prepareimageexport/json';
      let data = {};
      let currentObj = this;

      data.calculationsid = this.$route.params.calculationid
      data.lang = this.$i18n.locale;

      let merged = {...data, ...currentObj.session};
     
      axios.post(url, merged)
        .then(response => {
          if(response.data.success) {
            window.open(response.data.link);
          } else {
            alert('Leider trat ein unerwarteter Fehler bei der Erstellung des Bildes auf!')
          }
        }).catch(function () {
          currentObj.log('catch Function of AJAX-Called... error()');
          
        });
    }
  }
}
</script>

<style scoped>
</style>